import React, { useEffect, useState } from 'react'
import { View, useWindowDimensions, Pressable, Keyboard, TouchableOpacity, VirtualizedList, ActivityIndicator, RefreshControl, Image, DeviceEventEmitter } from 'react-native'
import { ThemeConsumer } from '@rneui/themed'
import Popover from 'react-native-popover-view/dist/Popover'
import moment from 'moment'

import { appColors } from '../../themes/appTheme'
import { config } from '../../shared/environment'
import { useKeyborad } from '../../shared/hooks/useKeyborad'

import CommonDialogBox from '../../shared/commonComponents/commonDialogBox'
import CommonHeader from '../../shared/commonComponents/commonHeader'
import { CustomModal } from '../../shared/commonComponents/customModal'

import { ZenButton, ZenCheckBox, ZenEmptyComponent, ZenIcon, ZenLoader, ZenPopover, ZenSearchBar, ZenText, ZenToast } from 'zen-core-elements'

import { selectedProductsProps, sortOptionProps } from './brandModule'
import { useAppNavigation, useAppRoute } from '../../types/@react-navigation/navigation'

import { getScreenPermission, useAppDispatch, useAppSelector } from '../../redux/hooks'
import { deleteBrandProducts } from '../../redux/slices/brandSlice'
import { shallowEqual } from 'react-redux'
import { ListToolbar } from '../../shared/commonComponents/listToolbar'
import { SortOption } from '../../shared/commonComponents/commonSortModal'
import { showApiError } from '../../shared/utils/handleApiError';
import { CategoryProductPayload, getMappedCategoryProducts } from '../../redux/slices/categorySlice'
import { CategoryProductItem } from '../category/categoryModule'


const ViewProduct = () => {
    const { isWrite: isBrandWrite } = useAppSelector(getScreenPermission("BrandStack"), shallowEqual)

    let limit = 10
    const dispatch = useAppDispatch()
    const route = useAppRoute('AllProductList')
    const { isAll, id, formikValues } = (route?.params || {}) as { isAll?: boolean, id?: number, formikValues?: any }
    const { createPosBrand: { loading: createPosBrandLoading }, updatePosBrand: { loading: updatePosBrandLoading } } = useAppSelector((state) => state?.brands)
    const { value: onePosBrandData } = useAppSelector((state) => state?.brands?.onePosBrand)
    const { value: allBrandProducts, count: allBrandProductsCount } = useAppSelector((state) => state?.brands?.allBrandProducts)
    console.log(allBrandProducts, "allBrandProducts");

    const { value: oneBrandProducts, count: oneBrandProductsCount, id: oneBrandProductsId } = useAppSelector((state) => state?.brands?.oneBrandProducts)
    const navigation = useAppNavigation()
    //Variable to mainatin offset value and limit of virtualized list
    const [offset, setOffset] = useState<number | null>(null)
    const [search, setSearch] = useState<string | null>(null)
    //Variable to control footer loader
    const [footerLoader, setFooterLoader] = useState(false)
    //Variable to maintain refresh control
    const [refresh, setRefresh] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const { width } = useWindowDimensions()
    const isKeyboardOpen = useKeyborad()
    const [sortOrder, setSortOrder] = useState<{ field: string, order: string, id: number } | null>(null)

    //Variable to maintain confirmation popup state while removing a brand product
    const [isRemovePopover, setIsRemovePopover] = useState<{ isVisible: boolean, productId: number[] }>({ isVisible: false, productId: [] })
    const [selectedProduct, setSelectedProduct] = useState<Set<number>>(new Set([]))

    const [currentBrandProducts, setCurrentBrandProducts] = useState<CategoryProductItem[]>([])

    //Variable to maintain sort values to display
    const sortOptionsData: SortOption[] = [
        { name: 'Product name A-Z', id: 1, field: 'name', order: 'ASC' },
        { name: 'Product name Z-A', id: 2, field: 'name', order: 'DESC' },
        { name: 'Recently created first', id: 3, field: 'created_at', order: 'DESC' },
        { name: 'Recently created last', id: 4, field: 'created_at', order: 'ASC' },
        { name: 'Recently updated first', id: 5, field: 'modified_at', order: 'DESC' },
        { name: 'Recently updated last', id: 6, field: 'modified_at', order: 'ASC' }
    ]

    useEffect(() => {
        if (isAll || id == undefined) {
            setCurrentBrandProducts([...allBrandProducts])
        } else {
            setCurrentBrandProducts(oneBrandProducts)
        }
    }, [allBrandProducts, oneBrandProducts, isAll, id])

    useEffect(() => {
        if (id == undefined || oneBrandProductsId != id || isAll) {
            toggleOffset()
        } else {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (search != null) {
            const debounceSearch = setTimeout(() => {
                toggleOffset()
            }, 1000);

            return () => clearTimeout(debounceSearch)
        }
    }, [search])

    useEffect(() => {
        if (offset !== null && (isAll || id != undefined))
            getBrandProducts()
    }, [offset])

    const toggleOffset = () => {
        setOffset((prev) => prev != -1 ? -1 : 0)
    }

    const toggleCheckBox = (id: number, selectAll?: boolean) => {
        if (id !== -1) {
            setSelectedProduct((prev) => {
                let data = new Set([...prev])
                if (data.has(id)) {
                    data.delete(id)
                } else {
                    data.add(id)
                }
                return data
            })
        } else {
            let selectedProducts: Set<number> = new Set([])
            if (selectAll) {
                currentBrandProducts?.forEach((item) => selectedProducts.add(item?.id))
            }
            setSelectedProduct(selectedProducts)
        }
    }

    const deleteProductApi = async () => {
        let brandId = id || onePosBrandData?.id
        if (!brandId) return
        let payload = { products: isRemovePopover?.productId?.length ? isRemovePopover?.productId : [...selectedProduct] }
        dispatch(deleteBrandProducts({ id: brandId, storeId: config?.storeId, payload })).unwrap().then(() => {
            setSelectedProduct(new Set([]))
            toggleOffset()
            ZenToast({
                type: "success",
                message: "Product removed successfully"
            })
        }).catch((error) => {
            setIsLoading(false)
            ZenToast({
                type: "error",
                message: "Error while deleting a product"
            })
            console.log("delete product error", error)
        })
    }

    const getBrandProducts = async () => {
        const payload: CategoryProductPayload = {
            storeId: config.storeId,
            data: {
                offset: (!offset || offset == -1) ? 0 : offset,
                limit: limit,
                searchText: search != null ? search.trim() : '',
                sortOrder: sortOrder ? JSON.stringify({ field: sortOrder.field, order: sortOrder.order }) : JSON.stringify({ field: "name", order: "asc" }),
                brandId: id ?? 0,
                isMapped: !isAll
            },
            isAllProduct: isAll!,
        }

        await dispatch(getMappedCategoryProducts(payload)).unwrap().catch(showApiError).finally(() => {
            setRefresh(false)
            setFooterLoader(false)
            setIsLoading(false)
        })
    }

    const deleteConfirmation = (value: { id: number }) => {
        if (value?.id == 2) {
            deleteProductApi()
        }
        setIsRemovePopover({ isVisible: false, productId: [] })
    }


    const renderItem = ({ item, index }: { item: selectedProductsProps[], index: number }) => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    <View key={index} style={{ flexDirection: "row" }}>
                        {item?.map((product: selectedProductsProps, ResponseDataIndex: number) => (
                            <View key={ResponseDataIndex} style={{ flex: 1 / (width > 600 ? 2 : 1) }}>
                                <Pressable style={{
                                    marginBottom: 10,
                                    marginHorizontal: 10,
                                    padding: 10,
                                    borderRadius: 5,
                                    backgroundColor: theme.light,
                                }} onPress={() => {
                                    isBrandWrite && toggleCheckBox(product?.id)
                                }}>
                                    <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                        <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                                            {isBrandWrite && <ZenCheckBox
                                                onPress={() => toggleCheckBox(product?.id)}
                                                checked={selectedProduct?.has(product?.id) ? true : false}
                                                checkedColor={appColors?.primary}
                                                containerStyle={{ marginLeft: 5 }}
                                            />}
                                            <Image
                                                source={product?.featuredImage ? { uri: `${config?.AWSImageUrl}${product?.featuredImage}` } : require('../../assets/noimage.jpg')}
                                                style={{
                                                    "width": 50,
                                                    "height": 50
                                                }}
                                                defaultSource={require('../../assets/noimage.jpg')}
                                            />
                                            <View style={{ gap: 5 }}>
                                                <ZenText content={product?.name} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark }} />
                                                <ZenText content={product?.createdAt ? moment(product?.createdAt).format("MMM DD, YYYY, hh:mm A") : "----"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
                                            </View>
                                        </View>
                                        {!isAll && id && isBrandWrite ? <TouchableOpacity onPress={() => {
                                            setIsRemovePopover({ isVisible: true, productId: [product?.id] })
                                        }}>
                                            <ZenIcon
                                                name='delete-outline'
                                                type='material-community'
                                                color={theme?.red}
                                                size={theme?.iconSize}
                                                style={{
                                                    "padding": 10,
                                                    "backgroundColor": theme.lightBackgroundColor,
                                                    "borderRadius": 10
                                                }}
                                            />
                                        </TouchableOpacity> : <></>}
                                    </View>
                                </Pressable>
                            </View>
                        ))}
                    </View>
                )}
            </ThemeConsumer>
        )
    }

    const getItem = (item: any[], index: number) => {
        let array: any = [];
        let numOfColumns = width >= 900 ? 2 : 1
        for (let i = 0; i < numOfColumns; i++) {
            let temp = item?.[index * numOfColumns + i];
            temp && array?.push(temp);
        }
        return array;
    };

    const footerComponent = () => {
        return (
            <ThemeConsumer>
                {({ theme }) => (
                    footerLoader ?
                        <View style={{}} >
                            <ActivityIndicator size={"small"} color={theme?.primary} />
                        </View >
                        : undefined
                )}
            </ThemeConsumer>
        )
    }

    const onRefresh = () => {
        setRefresh(true)
        setSortOrder(null)
        setSelectedProduct(new Set([]))
        if (search != "")
            setSearch("")
        else
            toggleOffset()
    }
    const onEndReached = () => {
        let offsetValue = (offset == -1 || !offset) ? 0 : offset
        let count = (isAll || id == undefined) ? allBrandProductsCount : oneBrandProductsCount
        if (!footerLoader && count > offsetValue) {
            setFooterLoader(true)
            setOffset(offsetValue + limit)
        }
    }
    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={{ flex: 1 }}>
                    {isAll && <CommonHeader
                        backIcon
                        backIconOnpress={() => { navigation?.goBack() }}
                        headerName='All Products List'
                        rightComponent={
                            isBrandWrite ? <ZenButton
                                title={"Save"}
                                titleColor={theme?.light}
                                disabled={selectedProduct?.size ? false : true}
                                buttonStyle={{ backgroundColor: theme?.primary, borderRadius: 10, }}
                                onPress={() => {
                                    const ids = Array.from(selectedProduct)
                                    DeviceEventEmitter?.emit("saveBrandData", ids)
                                }}
                            /> : undefined
                        }
                    />}

                    <View style={{ gap: 10, flex: 1, paddingTop: 10 }}>

                        <ListToolbar
                            search={{
                                placeholder: "Search by product name",
                                value: search ?? "",
                                onChange: (val) => setSearch(val as string),
                                onCancel: () => setSearch(null),
                            }}

                            sort={{
                                selectedId: sortOrder?.id,
                                onSelect: (item) => {
                                    setSortOrder(item as { field: string, order: string, id: number }); toggleOffset();
                                },
                                title: 'Sort by',
                                options: sortOptionsData

                            }}
                            buttons={isBrandWrite && !isAll ? [{
                                onPress: () => navigation?.navigate("AllProductList", { isAll: true, id, formikValues }),
                                title: `Add Product`,
                                variant: "primary"
                            }] : []}
                        />
                        {isLoading && (isAll || id != undefined) ?
                            <ZenLoader lottie={require('../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
                            <View style={{ flex: 1 }}>
                                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingHorizontal: 10, display: selectedProduct?.size ? "flex" : "none", paddingBottom: 10 }}>
                                    <ZenCheckBox
                                        title={selectedProduct?.size === currentBrandProducts.length ? "DeSelect All" : "Select All"}
                                        titleStyle={{ fontSize: theme.smallerFontSize }}
                                        containerStyle={{ marginLeft: 5, backgroundColor: "transparent" }}
                                        checkedColor={theme.primary}
                                        onPress={() => {
                                            if (selectedProduct?.size === currentBrandProducts.length)
                                                toggleCheckBox(-1, false)
                                            else
                                                toggleCheckBox(-1, true)
                                        }}
                                        checked={selectedProduct?.size === currentBrandProducts.length}
                                        size={20}
                                    />
                                    {!isAll && id && <TouchableOpacity style={theme?.customerListStyle?.optionInnerContainer} onPress={() => { setIsRemovePopover({ isVisible: true, productId: [] }) }}>
                                        <ZenText content={'Remove'} bold style={[theme?.customerListStyle?.optionTextStyle, { color: theme?.red }]} />
                                    </TouchableOpacity>}
                                </View>
                                <VirtualizedList
                                    keyExtractor={(_: any, index: number) => index?.toString()}
                                    getItemCount={(data: any) => data?.length}
                                    getItem={getItem}
                                    scrollEnabled={true}
                                    nestedScrollEnabled={true}
                                    renderItem={renderItem}
                                    data={(isAll || id != undefined) ? currentBrandProducts : []}
                                    keyboardDismissMode="on-drag"
                                    showsVerticalScrollIndicator={false}
                                    onEndReachedThreshold={0.01}
                                    contentContainerStyle={[{ paddingBottom: (isAll || id != undefined) && currentBrandProducts?.length ? 10 : undefined, flexGrow: (isAll || id != undefined) && currentBrandProducts?.length ? undefined : 1 }]}
                                    ListFooterComponent={footerComponent}
                                    ListFooterComponentStyle={{ height: (isAll || id != undefined) && currentBrandProducts?.length ? 70 : undefined }}
                                    ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
                                    onEndReached={onEndReached}
                                    refreshControl={<RefreshControl refreshing={refresh} onRefresh={onRefresh} />}
                                />
                            </View>
                        }
                    </View>
                    {
                        width < 600 && !isKeyboardOpen && !isAll &&
                        <Pressable style={{ position: "absolute", backgroundColor: theme.primary, width: 50, height: 50, borderRadius: 32, bottom: 40, right: 40, justifyContent: 'center', alignItems: "center" }}
                            onPress={() => { navigation?.navigate("AllProductList", { isAll: true, id, formikValues }) }}>
                            <ZenIcon type="material-community" name={"plus"} size={24} color={theme.light} />
                        </Pressable>
                    }
                    <Popover isVisible={isRemovePopover?.isVisible} popoverStyle={{ width: width > 600 ? 400 : 300, borderRadius: 10 }}>
                        <CommonDialogBox type='DELETE' replaceValue='product' confirmation={deleteConfirmation} />
                    </Popover>
                    <CustomModal visible={(createPosBrandLoading || updatePosBrandLoading) && !!isAll} transparent>
                        <ZenLoader transparent viewStyle={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "transparent" }} color={theme.primary} lottieType="Local" lottie={require('../../assets/infinityLoader.json')} />
                    </CustomModal>
                </View>
            )}
        </ThemeConsumer>
    )
}

export default ViewProduct